// extracted by mini-css-extract-plugin
export default {"Technologies":"Technologies_Technologies__9rBG5","Technologies_List":"Technologies_Technologies_List__utUFI"};